import { render, staticRenderFns } from "./PreAssessmentTips.vue?vue&type=template&id=1dc2373c&scoped=true&"
import script from "./PreAssessmentTips.vue?vue&type=script&lang=js&"
export * from "./PreAssessmentTips.vue?vue&type=script&lang=js&"
import style0 from "./PreAssessmentTips.vue?vue&type=style&index=0&id=1dc2373c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc2373c",
  null
  
)

export default component.exports